import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M32 0H0V32H32V0Z",
      class: "bg",
      fill: "#D7DBF7"
    }, null, -1),
    _createElementVNode("path", {
      d: "M20.6667 8.66699H11.3333C9.86056 8.66699 8.66666 9.8609 8.66666 11.3337V20.667C8.66666 22.1398 9.86056 23.3337 11.3333 23.3337H20.6667C22.1394 23.3337 23.3333 22.1398 23.3333 20.667V11.3337C23.3333 9.8609 22.1394 8.66699 20.6667 8.66699Z",
      class: "primary",
      fill: "#151F6D"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.92001 17.6936C6.95739 17.7241 7.00269 17.7432 7.05059 17.7488C7.09848 17.7544 7.14698 17.7463 7.19038 17.7253C7.23379 17.7043 7.2703 17.6713 7.29562 17.6303C7.32095 17.5892 7.33403 17.5418 7.33335 17.4936V14.5069C7.33403 14.4587 7.32095 14.4113 7.29562 14.3703C7.2703 14.3292 7.23379 14.2963 7.19038 14.2753C7.14698 14.2543 7.09848 14.2461 7.05059 14.2517C7.00269 14.2573 6.95739 14.2765 6.92001 14.3069L5.05335 15.8003C5.02288 15.824 4.99823 15.8543 4.98128 15.889C4.96432 15.9236 4.95551 15.9617 4.95551 16.0003C4.95551 16.0389 4.96432 16.0769 4.98128 16.1116C4.99823 16.1463 5.02288 16.1766 5.05335 16.2003L6.92001 17.6936Z",
      class: "secondary",
      fill: "#959FEB"
    }, null, -1),
    _createElementVNode("path", {
      d: "M25.08 17.6936C25.0426 17.7241 24.9973 17.7432 24.9494 17.7488C24.9015 17.7544 24.853 17.7463 24.8096 17.7253C24.7662 17.7043 24.7297 17.6713 24.7044 17.6303C24.6791 17.5892 24.666 17.5418 24.6667 17.4936V14.5069C24.666 14.4587 24.6791 14.4113 24.7044 14.3703C24.7297 14.3292 24.7662 14.2963 24.8096 14.2753C24.853 14.2543 24.9015 14.2461 24.9494 14.2517C24.9973 14.2573 25.0426 14.2765 25.08 14.3069L26.9467 15.8003C26.9771 15.824 27.0018 15.8543 27.0187 15.889C27.0357 15.9236 27.0445 15.9617 27.0445 16.0003C27.0445 16.0389 27.0357 16.0769 27.0187 16.1116C27.0018 16.1463 26.9771 16.1766 26.9467 16.2003L25.08 17.6936Z",
      class: "secondary",
      fill: "#959FEB"
    }, null, -1)
  ])))
}
export default { render: render }